/**
 * Check if the application is running in development mode
 * In SST v3, we use the ENV environment variable set in sst.config.ts
 */
export function isDev(): boolean {
  // When running locally with `sst dev`, ENV will be "local" or the stage name
  // In production, ENV will be "production"
  return process.env.ENV !== "production"
}

/**
 * Get the current stage name
 */
export function getStage(): string {
  return process.env.ENV || "unknown"
}
